import { gsap } from "gsap";

document.querySelectorAll(".agenda__item").forEach((item) => {
  const glow = item.querySelector(".glow");

  item.addEventListener("mousemove", (e) => {
    const rect = item.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    gsap.to(glow, {
      x: x,
      y: y - 200,
      duration: 0.3,
      ease: "power3.out",
    });
  });

  item.addEventListener("mouseenter", () => {
    gsap.to(glow, {
      scale: 1,
      duration: 0.3,
      ease: "power2.out",
    });
  });

  item.addEventListener("mouseleave", () => {
    gsap.to(glow, {
      scale: 0,
      duration: 0.3,
      ease: "power2.in",
    });
  });
});
